import Vue from 'vue';
import Vuetify, {
  VApp,
  VAppBar,
  VContent,
  VContainer,
  VCol,
  VRow,
  VCard,
  VCardActions,
  VImg,
  VCardText,
  VCardTitle,
  VList,
  VListItem,
  VListItemTitle,
  VListItemSubtitle,
  VListItemContent,
  VListItemGroup,
  VListItemIcon,
  VIcon,
  VTextField,
  VForm,
  VBtn
} from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#0090ba',
        secondary: '#6f6f74',
        accent: '#afcd68',
        error: '#C10015',
        info: '#31CCEC',
        success: '#21BA45',
        warning: '#F2C037'
      },
      dark: {
        primary: '#0090ba',
        secondary: '#6f6f74',
        accent: '#afcd68',
        error: '#C10015',
        info: '#31CCEC',
        success: '#21BA45',
        warning: '#F2C037'
      }
    }
  },
  icons: {
    iconfont: 'mdi',
  },
  components: {
    VApp,
    VAppBar,
    VContent,
    VContainer,
    VCol,
    VRow,
    VCard,
    VCardActions,
    VImg,
    VCardText,
    VCardTitle,
    VList,
    VListItem,
    VListItemTitle,
    VListItemSubtitle,
    VListItemContent,
    VListItemGroup,
    VListItemIcon,
    VIcon,
    VTextField,
    VForm,
    VBtn
  }
});
